import ApiService from "../ApiService";
import { StorageService } from "../StorageService";

const orderDetailsService = {

    deleteMedicine(listMedicine) {
        return ApiService.post('/scheduling/remove/', listMedicine);
    },

};

export default orderDetailsService;